import { CommonModule } from '@angular/common';
import { Component, OnInit, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';


@Component({
  selector: 'no-services',
  templateUrl: './no-services.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, ButtonModule, TranslateModule]
})
export class NoServicesComponent implements OnInit {

  @Output() onAction = new EventEmitter();
  constructor() { }

  ngOnInit(): void {
  }

  addServiceModal() {
    this.onAction.emit({ action: "createService" });
  }
}